// Mock data for Bruno Rodrigues Fit Website

export const pricingPlans = [
  {
    id: 1,
    name: 'Plano 30 dias',
    price: '69,90€',
    duration: '30 dias',
    stripeLink: 'https://buy.stripe.com/9B64gr1Lu15RemH0f75wI05',
    features: [
      { text: 'Acesso à Plataforma/App', included: true },
      { text: 'Plano de Treino e Nutrição Personalizado', included: true },
      { text: 'Suporte e Apoio 24/7', included: true },
      { text: 'Videochamada com o Bruno e nutricionista', included: true },
      { text: 'Possibilidade de Pagamento em Prestações', included: false }
    ]
  },
  {
    id: 2,
    name: 'Plano 90 dias',
    price: '159,90€',
    duration: '90 dias',
    stripeLink: 'https://buy.stripe.com/eVq4gr4XG7ufa6r6Dv5wI06',
    features: [
      { text: 'Acesso à Plataforma/App', included: true },
      { text: 'Plano de Treino e Nutrição Personalizado', included: true },
      { text: 'Suporte e Apoio 24/7', included: true },
      { text: 'Videochamada com o Bruno e nutricionista', included: true },
      { text: 'Possibilidade de Pagamento em 3x', included: true }
    ],
    badge: 'Pague em 3x'
  },
  {
    id: 3,
    name: 'Plano 180 dias',
    price: '259,90€',
    duration: '180 dias',
    stripeLink: 'https://buy.stripe.com/4gM3cnbm47ufbav2nf5wI07',
    featured: true,
    features: [
      { text: 'Acesso à Plataforma/App', included: true },
      { text: 'Plano de Treino e Nutrição Personalizado', included: true },
      { text: 'Suporte e Apoio 24/7', included: true },
      { text: 'Videochamada com o Bruno e nutricionista', included: true },
      { text: 'Possibilidade de Pagamento em 3x', included: true }
    ],
    badge: 'Mais Procurado'
  },
  {
    id: 4,
    name: 'Plano 365 dias',
    price: '399,90€',
    duration: '365 dias',
    stripeLink: 'https://buy.stripe.com/4gw7v03A4fF4cLe003',
    features: [
      { text: 'Acesso à Plataforma/App', included: true },
      { text: 'Plano de Treino e Nutrição Personalizado', included: true },
      { text: 'Suporte e Apoio 24/7', included: true },
      { text: 'Videochamada com o Bruno e nutricionista', included: true },
      { text: 'Possibilidade de Pagamento em 3x', included: true }
    ],
    badge: 'Pague em 3x'
  }
];

export const testimonials = [
  {
    id: 1,
    image: 'https://images.pexels.com/photos/7991940/pexels-photo-7991940.jpeg',
    alt: 'Cliente 1 - Transformação'
  },
  {
    id: 2,
    image: 'https://images.pexels.com/photos/7991916/pexels-photo-7991916.jpeg',
    alt: 'Cliente 2 - Transformação'
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1522844990619-4951c40f7eda',
    alt: 'Cliente 3 - Transformação'
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1591384640699-9a85bd036da2',
    alt: 'Cliente 4 - Transformação'
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1634463278803-f9f71890e67d',
    alt: 'Cliente 5 - Transformação'
  },
  {
    id: 6,
    image: 'https://images.pexels.com/photos/6670943/pexels-photo-6670943.jpeg',
    alt: 'Cliente 6 - Transformação'
  }
];

export const transformations = [
  {
    id: 1,
    beforeImage: 'https://images.unsplash.com/photo-1522844990619-4951c40f7eda',
    afterImage: 'https://images.pexels.com/photos/7991940/pexels-photo-7991940.jpeg',
    name: 'Maria S.'
  },
  {
    id: 2,
    beforeImage: 'https://images.unsplash.com/photo-1634463278803-f9f71890e67d',
    afterImage: 'https://images.pexels.com/photos/7991916/pexels-photo-7991916.jpeg',
    name: 'João P.'
  },
  {
    id: 3,
    beforeImage: 'https://images.pexels.com/photos/6670943/pexels-photo-6670943.jpeg',
    afterImage: 'https://images.unsplash.com/photo-1591384640699-9a85bd036da2',
    name: 'Ana R.'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'O que é o Programa de Acompanhamento Personalizado?',
    answer: 'É um serviço 100% online criado pelo Personal Trainer Bruno Rodrigues, especialista em perda de peso. Combina um plano de treino físico fundamental e um plano de nutrição flexível, focados em emagrecer com saúde e de forma sustentável, sem dietas malucas.'
  },
  {
    id: 2,
    question: 'Este plano é só para emagrecer?',
    answer: 'Não. Embora a perda de peso seja o objetivo principal, o foco do nosso método é ganhar saúde, energia e bem estar. O emagrecimento acontece como uma consequência natural e sustentável da adoção de hábitos saudáveis e do treino fundamental.'
  },
  {
    id: 3,
    question: 'O Programa de Acompanhamento Personalizado é para mim?',
    answer: 'Sim, é para quem procura resultados duradouros, está cansado de restrições alimentares e quer aprender a comer de tudo com saúde. É ideal para quem precisa de um plano de treino adaptado e do suporte de um especialista para garantir a consistência.'
  },
  {
    id: 4,
    question: 'Qual o valor do Programa de Acompanhamento Personalizado?',
    answer: 'Temos 4 opções de valor que se adaptam à tua dedicação: Plano Mensal: 69,90€ | Plano Trimestral: 159,90€ | Plano Semestral: 259,90€ | Plano Anual: 399,90€. Os planos mais longos oferecem uma maior poupança e mais suporte personalizado.'
  },
  {
    id: 5,
    question: 'O pagamento é seguro?',
    answer: 'Sim, você irá realizar o pagamento em uma plataforma 100% segura e conhecida pelo mercado.'
  },
  {
    id: 6,
    question: 'O que está incluído?',
    answer: 'O plano inclui: Plano de Treino Fundamental personalizado, Orientações de Nutrição Flexível (comer de tudo), acesso à plataforma exclusiva, vídeos explicativos de execução e acompanhamento direto via chat com o Personal Trainer Bruno.'
  },
  {
    id: 7,
    question: 'Quais os meios de pagamentos disponibilizados?',
    answer: 'Aceitamos pagamentos via Cartão de Crédito/Débito, Transferência Bancária; MBway e Multibanco. Nos planos Semestral e Anual, existe a possibilidade de pagar em prestações.'
  },
  {
    id: 8,
    question: 'Ao entrar no Programa de Acompanhamento Personalizado tenho acesso ao quê?',
    answer: 'Terás acesso total à nossa plataforma/app exclusiva, onde encontras todos os teus planos, vídeos de execução dos exercícios, registo de progresso e o canal de comunicação direta com o Personal Trainer Bruno.'
  }
];

export const stats = [
  { label: 'Anos de experiência em perda de peso', value: '10+' },
  { label: 'Horas de treinos dados', value: '59k+' },
  { label: 'Taxa de retenção', value: '99%' }
];

// Removed ebooks section - not used in Bruno Rodrigues site

export const features = [
  {
    id: 1,
    title: 'Acesso à App',
    description: 'Plataforma exclusiva para ti'
  },
  {
    id: 2,
    title: 'Plano de Treino',
    description: 'Personalizado e fundamental'
  },
  {
    id: 3,
    title: 'Plano de Nutrição',
    description: 'Flexível - come de tudo'
  },
  {
    id: 4,
    title: 'Vídeos Explicativos',
    description: 'Execução correta dos exercícios'
  },
  {
    id: 5,
    title: 'Suporte 24/7',
    description: 'Apoio constante da equipa'
  },
  {
    id: 6,
    title: 'Acompanhamento',
    description: 'Contacto direto com o Bruno'
  },
  {
    id: 7,
    title: 'Progresso',
    description: 'Registo de evolução'
  }
];